import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslocoModule, TranslocoService } from '@ngneat/transloco';

@Component({
  standalone: true,
  imports: [CommonModule, TranslocoModule, RouterModule],
  selector: 'app-zaa-breadcumb',
  templateUrl: './zaa-breadcumb.component.html',
  styleUrls: ['./zaa-breadcumb.component.css'],
})
export class ZaaBreadcumbComponent implements OnInit {
  @Input() breadcumbs: Array<{ label: string, url: string }> = [];
  @Input() enableLanguage: boolean = false; // Enable language - each breadcumbs is key path.
  @Input() activeIndex: number = 0;
  @Input() enableDisplayDate: boolean = false; // Enable display date
  @Input() marginBottom: string = "mb-3"; // Enable display date

  languageService = inject(TranslocoService);
  displayDay: string = '';
  constructor() {}

  ngOnInit() {
    const today = new Date();
    const activeLanguage = this.languageService.getActiveLang();
    if (activeLanguage == 'es') {
      this.displayDay = today.toLocaleDateString('en', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    } else {
      this.displayDay = today.toLocaleDateString('vi', {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    }
  }
}
